import { render, staticRenderFns } from "./FileBusiness.vue?vue&type=template&id=2bb5261a&scoped=true"
import script from "./FileBusiness.vue?vue&type=script&lang=ts"
export * from "./FileBusiness.vue?vue&type=script&lang=ts"
import style0 from "./FileBusiness.vue?vue&type=style&index=0&id=2bb5261a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb5261a",
  null
  
)

export default component.exports